import {
  Button,
  Dialog,
  DialogTitle,
  Paper,
  TextField,
  Grid,
  Typography,
} from "@mui/material";
import { Stack } from "@mui/system";
import DoneIcon from '@mui/icons-material/Done';
import { useSelector } from "react-redux";
import { setIsLoading, setUserToken } from "../../../../../features/userSlice";
import { useDispatch } from "react-redux";
import { useState } from "react";
import { MetaEntitiesEndPointLogic } from "../../../../../logic/Admin/MetaEntities/MetaEntitiesEndPointLogic";
import SimpleBackdrop from "../../../../BackDrop/BackDrop";

interface TerritoryProps {
  open: boolean;
  handleClose: () => void;
}

function CreateTerritoryModal({
  open,
  handleClose
}: TerritoryProps) {

  const token = useSelector(setUserToken);
  const outhTokenHeader = token?.payload?.user?.userToken;
  const dispatch = useDispatch();

  const [territoryName, SetTerritoryName] = useState(null);
  const [language, SetLanguage] = useState(null);
  const [loading, setLoading] = useState(false);

  const CreateNewTrafficClickIdentifier = async() => {
        const data = {
          territory_name: territoryName,
          language: language,
        };
        try{
          setIsLoading(true);
          setLoading(true);
          if (outhTokenHeader) {
            await MetaEntitiesEndPointLogic.createMetaTerritory(outhTokenHeader, data);
          } else {
            throw new Error("User doesn't have permissions to create new themes");
          }
          if(outhTokenHeader) {
            setIsLoading(true);
            await MetaEntitiesEndPointLogic.getMetaTerritory(outhTokenHeader,dispatch);
          }
        } catch (error) {
          console.error(error, "error");
        } finally{
          setLoading(false);
          setIsLoading(false);
          handleClose();
          SetLanguage(null);
          SetTerritoryName(null);
          await MetaEntitiesEndPointLogic.getMetaTerritory(outhTokenHeader,dispatch);
        }
      };

  return (
    <>
    {loading ? <SimpleBackdrop /> : (
      <Dialog
      open={open}
      onClose={handleClose}
      PaperProps={{ sx: { width: "900px", maxWidth: "900px" } }}
    >
      <Paper sx={{ padding: "16px 24px 20px 24px" }}>
        <DialogTitle sx={{ padding: "0px 0px 16px 0px" }}>
        Create New Territory
        </DialogTitle>
        <Typography sx={{mb:1}}>Details</Typography>
        <Grid container mt={0} columnSpacing={3}>
          <Grid item xs={6}>
            <TextField
              value={territoryName}
              onChange={(e: any) => SetTerritoryName(e.target.value)}
              id="outlined-multiline-flexible"
              label="Territory Name *" // Set your label here
              placeholder="Enter unique territory Name" // Set your placeholder here
              color="secondary"
              size="small"
              fullWidth
            />
          </Grid>
          <Grid item xs={6}>
            <TextField
              value={language}
              onChange={(e: any) => SetLanguage(e.target.value)}
              id="outlined-multiline-flexible"
              label="Language *" // Set your label here
              placeholder="Define language for this territory" // Set your placeholder here
              color="secondary"
              size="small"
              fullWidth
            />
          </Grid>
        </Grid>
        <Typography
          sx={{ fontSize: "12px", marginTop: "8px", color: "#00000099" }}
        >
          All fields are mandatory.
        </Typography>

        <Stack flexDirection={"row"} justifyContent={"end"} marginTop={2}>
          <Button color="secondary" onClick={handleClose} sx={{mr:1}}>
            CANCEL
          </Button>
          <Button variant="contained" color="secondary" disabled={!territoryName || !language} data-tracker="237" onClick={CreateNewTrafficClickIdentifier}>
          Create <DoneIcon sx={{ml:1}} />
          </Button>
        </Stack>
      </Paper>
    </Dialog>
    )}
    </>
  );
}

export default CreateTerritoryModal;
